import { useEffect } from 'react';
import { Button, Form, Radio, Typography } from 'antd';
import BaseModal from 'components/modules/BaseModal';

type Props = {
    isOpen: boolean;
    onCancel: () => void;
    onSubmit: (values: { enable: boolean }) => void;
};

const MfaPermissionModal: React.FC<Props> = ({
    isOpen,
    onCancel,
    onSubmit,
}) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (!isOpen) return;
        form.resetFields();
    }, [form, isOpen])

    const onFinish = (values: { enable: boolean }) => {
        onCancel();
        onSubmit(values);
    };

    return (
        <BaseModal
            visible={isOpen}
            title='多要素認証の登録を許可する'
            footer={[
                <Button
                    key='cancel'
                    size='large'
                    onClick={onCancel}
                >
                    キャンセル
                </Button>,
                <Button
                    key='save'
                    size='large'
                    type='primary'
                    onClick={form.submit}
                >
                    実行
                </Button>,
            ]}
            onCancel={onCancel}
            maskClosable={false}
            width={480}
        >
            <Typography.Paragraph>
                選択した全体管理者ユーザーによる認証アプリの設定を許可します。
                <br/>
                許可されたユーザーが、認証アプリを登録していない状態で全体管
                理画面にログインする場合、認証アプリの登録画面が表示されるよ
                うになります。
            </Typography.Paragraph>
            <Typography.Paragraph>
                認証アプリを登録済みの全体管理者の多要素認証の設定を許可しな
                いに変更する場合、登録済みの認証アプリの設定がリセットされま
                す。また、全体管理画面へのログインに多要素認証を要求している
                場合、そのユーザーは全体管理画面にログインできなくなります。
            </Typography.Paragraph>

            <Form
                form={form}
                onFinish={onFinish}
            >
                <Form.Item
                    required
                    label='このユーザーの多要素認証の設定を許可する'
                    name='enable'
                    labelCol={{ span: 24 }}
                    style={{ marginBottom: 0 }}
                >
                    <Radio.Group>
                        <Radio value={true}>する</Radio>
                        <Radio value={false}>しない</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </BaseModal>
    );
};

export default MfaPermissionModal;
